import { NgModule } from '@angular/core';
import { HighlightifyPipe } from './highlightify/highlightify';
import { TruncatePipe } from './truncate/truncate';
import { PhonePipe } from './phone/phone';
@NgModule({
	declarations: [HighlightifyPipe,
    TruncatePipe,
    PhonePipe],
	imports: [],
	exports: [HighlightifyPipe,
    TruncatePipe,
    PhonePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts